import Icon from '../components/Icon.vue'

Icon.register({
  drum: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M458.1 120.9c71.4 23.3 117.9 60.8 117.9 103.1v160.8c0 30.5-24 58.4-64 80.4v-96.4c0-17.6-14.4-32-32-32s-32 14.4-32 32v122.4c-37.4 11.1-81 18.4-128 20.8v-111.2c0-17.6-14.4-32-32-32s-32 14.4-32 32v111.2c-47-2.3-90.6-9.6-128-20.8v-122.4c0-17.6-14.4-32-32-32s-32 14.4-32 32v96.4c-40-22-64-49.9-64-80.4v-160.8c0-70.7 128.9-128 288-128 21.8 0 57.2 2.2 78.8 5l160.7-96.4c15.2-9.1 34.8-4.2 43.9 11 9.1 15.2 4.2 34.8-11 43.9zM288 304c132.5 0 240-35.8 240-80 0-30.3-50.5-56.6-124.8-70.2l-162.7 97.6c-14.4 8.6-34.3 5-43.9-11-9.1-15.2-4.2-34.8 11-43.9l87.4-52.4c-2.3 0-4.6-0.1-6.9-0.1-132.6 0-240 35.8-240 80s107.5 80 240 80z'
      }
    ]
  }
})
